export const DATE_FORMAT = `DD/MM/YYYY`;
export enum CURRENCIES {
  USD = "usd",
  EUR = "eur",
  RUB = "rub",
  CNY = "cny",
  JPY = "jpy",
}

export const CURRENCIES_ARR = [
  CURRENCIES.USD,
  CURRENCIES.EUR,
  CURRENCIES.RUB,
  CURRENCIES.CNY,
  CURRENCIES.JPY,
];
